// src/pages/Racing.js
import React from 'react';
import { Link } from 'react-router-dom';

function Racing() {
  return (
    <div className="page">
      {/* Hero-style intro */}
      <div style={{
        background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
        padding: '3rem 2rem',
        borderRadius: '20px',
        textAlign: 'center',
        marginBottom: '2rem',
        border: '1px solid rgba(59, 130, 246, 0.2)'
      }}>
        <h1 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '2.5rem' }}>🏁 Racing with DC Hawks</h1>
        <p style={{ fontSize: '1.2rem', color: '#4A5568', maxWidth: '600px', margin: '0 auto' }}>
          Discover the joy of competition in a supportive, no-pressure environment!
          Racing is optional, but the memories last forever. 🌟
        </p>
      </div>

      {/* Philosophy Cards */}
      <div className="highlights">
        <div className="highlight-card">
          <h3>🎯 No Pressure Zone</h3>
          <p>Racing is always optional and should be fun! We're here to support, not stress.</p>
        </div>

        <div className="highlight-card">
          <h3>🤝 All Levels Welcome</h3>
          <p>From first-timers to experienced competitors, everyone has a place!</p>
        </div>

        <div className="highlight-card">
          <h3>📈 Personal Goals</h3>
          <p>Focus on individual improvement and personal bests!</p>
        </div>

        <div className="highlight-card">
          <h3>🎉 Team Spirit</h3>
          <p>Cheering for teammates, celebrating efforts, and learning from every experience together!</p>
        </div>
      </div>

      <div className="content-section">
        <h2>Why Kids Love Racing with DC Hawks</h2>
        <p>
          Racing is optional with DC Hawks, but many of our athletes discover
          they love the challenge and excitement of competition. We participate in races
          throughout the DMV that welcome youth runners of all abilities.
        </p>
      </div>

      <div className="content-section">
        <h2>What You Need to Race</h2>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem', marginTop: '1.5rem' }}>
          <div>
            <h3 style={{ color: '#2A4BA0', marginBottom: '1rem' }}>🛡️ AAU Membership</h3>
            <div style={{ background: '#f8fafc', padding: '1.5rem', borderRadius: '8px' }}>
              <p><strong>Cost:</strong> $20 annually</p>
              <p><strong>When:</strong> Renewed each fall</p>
              <p><strong>Why:</strong> Required for AAU-sanctioned races</p>
            </div>
          </div>

          <div>
            <h3 style={{ color: '#2A4BA0', marginBottom: '1rem' }}>💰 Race Entry Fees</h3>
            <div style={{ background: '#f8fafc', padding: '1.5rem', borderRadius: '8px' }}>
              <p><strong>Range:</strong> $8-15 per race</p>
            </div>
          </div>
        </div>
      </div>

      <div className="content-section">
        <h2>Current Race Calendar</h2>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginTop: '2rem' }}>
          <div style={{ background: '#fff7ed', padding: '2rem', borderRadius: '12px', border: '1px solid #fed7aa' }}>
            <h3 style={{ color: '#c2410c', marginBottom: '1rem', fontSize: '1.4rem' }}>🍂 Fall 2026 Cross Country</h3>
            <p style={{ fontSize: '1rem', color: '#666', marginBottom: '1rem' }}>September – November 2026</p>

            <div style={{ fontSize: '1rem' }}>
              <div style={{ marginBottom: '0.8rem', padding: '0.75rem', background: 'rgba(251, 146, 60, 0.08)', borderRadius: '6px' }}>
                <strong style={{ fontSize: '1.05rem' }}>Sun, Sep 13</strong> - Westminster XC Invitational<br />
                <span style={{ color: '#666', fontSize: '0.95rem' }}>📍 Robert Moton Elementary School, MD</span>
              </div>
              <div style={{ marginBottom: '0.8rem', padding: '0.75rem', background: 'rgba(251, 146, 60, 0.08)', borderRadius: '6px' }}>
                <strong style={{ fontSize: '1.05rem' }}>Sun, Sep 20</strong> - Catoctin Youth XC Challenge<br />
                <span style={{ color: '#666', fontSize: '0.95rem' }}>📍 Catoctin High School, MD</span>
              </div>
              <div style={{ marginBottom: '0.8rem', padding: '0.75rem', background: 'rgba(251, 146, 60, 0.08)', borderRadius: '6px' }}>
                <strong style={{ fontSize: '1.05rem' }}>Sun, Sep 27</strong> - Middletown Youth Cross Country Invitational<br />
                <span style={{ color: '#666', fontSize: '0.95rem' }}>📍 Middletown Park, MD</span>
              </div>
              <div style={{ marginBottom: '0.8rem', padding: '0.75rem', background: 'rgba(251, 146, 60, 0.08)', borderRadius: '6px' }}>
                <strong style={{ fontSize: '1.05rem' }}>Sun, Oct 4</strong> - Catonsville Youth XC Invite<br />
                <span style={{ color: '#666', fontSize: '0.95rem' }}>📍 Catonsville High School, MD</span>
              </div>
              <div style={{ marginBottom: '0.8rem', padding: '0.75rem', background: 'rgba(251, 146, 60, 0.08)', borderRadius: '6px' }}>
                <strong style={{ fontSize: '1.05rem' }}>Sun, Oct 11</strong> - Bullseye Youth XC Challenge<br />
                <span style={{ color: '#666', fontSize: '0.95rem' }}>📍 Centennial HS, MD</span>
              </div>
              <div style={{ marginBottom: '0.8rem', padding: '0.75rem', background: 'rgba(251, 146, 60, 0.08)', borderRadius: '6px' }}>
                <strong style={{ fontSize: '1.05rem' }}>Sun, Oct 18</strong> - Frederick Blaze Cross Country Invitational<br />
                <span style={{ color: '#666', fontSize: '0.95rem' }}>📍 Governor Thomas Johnson HS, MD</span>
              </div>
              <div style={{ marginBottom: '0.8rem', padding: '0.75rem', background: 'rgba(251, 146, 60, 0.08)', borderRadius: '6px' }}>
                <strong style={{ fontSize: '1.05rem' }}>Sun, Oct 25</strong> - Eldersburg Arrows XC Invite<br />
                <span style={{ color: '#666', fontSize: '0.95rem' }}>📍 Century HS, MD</span>
              </div>
              <div style={{ marginBottom: '0.8rem', padding: '0.75rem', background: 'rgba(251, 146, 60, 0.08)', borderRadius: '6px' }}>
                <strong style={{ fontSize: '1.05rem' }}>Sun, Nov 1</strong> - CMRC Halloween XC Challenge<br />
                <span style={{ color: '#666', fontSize: '0.95rem' }}>📍 Carroll Manor Elementary School, MD</span>
              </div>
              <div style={{ marginBottom: '0.8rem', padding: '0.75rem', background: 'linear-gradient(135deg, #fed7aa 0%, #fdba74 100%)', borderRadius: '6px', border: '1px solid #fb923c' }}>
                <strong style={{ fontSize: '1.05rem' }}>Sat, Nov 14</strong> - Middle School XC Nationals 2026 ⭐<br />
                <span style={{ color: '#555', fontSize: '0.95rem' }}>📍 E.P. Tom Sawyer State Park, Louisville, KY</span><br />
                <span style={{ color: '#c2410c', fontSize: '0.85rem', fontStyle: 'italic' }}>National championship meet · </span>
                <a href="https://thevashowcase.com/middle-school-nats-info-1" target="_blank" rel="noopener noreferrer" style={{ color: '#c2410c', fontSize: '0.85rem' }}>🔗 Meet Website</a>
              </div>
            </div>

            <div style={{ marginTop: '1.25rem', padding: '1rem', background: 'white', borderRadius: '8px', border: '1px dashed #fb923c' }}>
              <p style={{ margin: 0, fontSize: '0.95rem', color: '#666' }}>
                Every meet is optional, and we rarely make all of them. Details for each
                race go out in the WhatsApp group the week before.
              </p>
            </div>
          </div>
        </div>

        <div style={{
          background: '#f5f3ff',
          padding: '2rem',
          borderRadius: '12px',
          margin: '2rem 0',
          textAlign: 'center',
          border: '1px solid #c4b5fd'
        }}>
          <h3 style={{ color: '#7c3aed', marginBottom: '1rem' }}>⭐ Year-Round Constant</h3>
          <p style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}><strong>Every Saturday 9:00 AM</strong></p>
          <p style={{ margin: 0 }}>Fletcher's Cove Parkrun—our weekly home base where it all happens!</p>
        </div>

        <div style={{
          background: '#fffaf0',
          padding: '2rem',
          borderRadius: '12px',
          margin: '2rem 0',
          border: '1px solid #fbd38d'
        }}>
          <h3 style={{ color: '#d69e2e', marginBottom: '1rem' }}>🎽 Race Day Gear Checklist</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
            <div>✅ <strong>Running shoes</strong> (spikes optional)</div>
            <div>✅ <strong>Comfortable clothes</strong></div>
            <div>✅ <strong>Water bottle</strong></div>
            <div>✅ <strong>Positive attitude!</strong> 😊</div>
          </div>
        </div>

        {/* Link to Archive */}
        <div style={{
          background: '#fef3c7',
          padding: '1.5rem',
          borderRadius: '12px',
          margin: '2rem 0',
          textAlign: 'center',
          border: '1px solid #fcd34d'
        }}>
          <h3 style={{ color: '#92400e', marginBottom: '0.5rem' }}>📚 Past Seasons</h3>
          <p style={{ marginBottom: '1rem', color: '#666' }}>
            Every meet from our outdoor, indoor, and cross country seasons—including the
            2026 outdoor track season that just wrapped up.
          </p>
          <Link
            to="/racing-archive"
            style={{
              display: 'inline-block',
              padding: '0.75rem 1.5rem',
              background: '#f59e0b',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: 'bold',
              transition: 'background 0.3s'
            }}
          >
            View Past Seasons →
          </Link>
        </div>

        {/* Hardy Middle School record book */}
        <div style={{
          background: '#fffbeb',
          padding: '1.5rem',
          borderRadius: '12px',
          margin: '2rem 0',
          textAlign: 'center',
          border: '1px solid #fbbf24'
        }}>
          <h3 style={{ color: '#92400e', marginBottom: '0.5rem' }}>🏅 Hardy MS Record Book</h3>
          <p style={{ marginBottom: '1rem', color: '#666' }}>
            Run for Hardy Middle School too? Coach Dario keeps the cross country and
            track record book school records plus every performance available online.
          </p>
          <a
            href="https://dareios82.github.io/hardy-xc-track-records/index.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '0.75rem 1.5rem',
              background: '#d97706',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: 'bold'
            }}
          >
            View Hardy Records ↗
          </a>
        </div>
      </div>
    </div>
  );
}

export default Racing;
